import api from "../api/api";
import { UsuarioEnderecos } from "../provider/auth/AuthProps";

export const usuarioService = {
    getUsuarioAutocomplete: async (telefone?: string, token?: string) => {
        try {
            const response = await api.get(`/usuario/busca`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    telefone,
                }            
            });
            return response.data;
        } catch (error: any) {
            throw {
                status: error.response.status,
                message: error.response.message,
            };
        }
    },

    getPedidosUsuario: async (id: number, token: string) => {
        try {
            const response = await api.get(`/usuario/${id}/pedidos`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error: any) {
            if (error.response) {
                throw error.response.data;
            }
    
            // erro de rede ou inesperado
            throw {
                status: 500,
                message: "Erro inesperado",
            };
        }
    },

    salvaEnderecoPorTelefone: (telefone: string, endereco: UsuarioEnderecos) => {
        const dados = localStorage.getItem("enderecosPorTelefone");

        const banco = dados
            ? JSON.parse(dados)
            : {};

        banco[telefone] = [
            ...(banco[telefone] || []),
            endereco
        ];

        localStorage.setItem(
            "enderecosPorTelefone",
            JSON.stringify(banco)
        );
    },

    getEnderecosPorTelefoneLocalStorage: (
        telefone: string
    ) => {
    
        const dados = localStorage.getItem("enderecosPorTelefone");
    
        if (!dados) {
            return [];
        }
    
        const banco = JSON.parse(dados);
    
        return banco[telefone] || [];
    }
};